import React, {useRef} from 'react';
import './/StyleComponents/HomeEducation.css';
import useIntersectionObserver from "./useIntersectionObserver";



const HomeEducation = () => {

    const HeaderRef = useRef(null);
    const isVisible = useIntersectionObserver(HeaderRef, { rootMargin: '100px' });

    return (


        <div>
            <div  className="EducationContainer">
                <h1  ref={HeaderRef} className={`EducationHeader ${isVisible ? 'visible' : ''}`}>
                    Education
                </h1>
                <div className="EducationBox">
                    <div className="ConcordiaEducation">
                        <h1 style={{ fontSize: "1.5em" }}>
                            <a
                                href="https://www.concordia.ca/academics/undergraduate/software-engineering.html"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="RefHeader"
                            >
                                Concordia University
                            </a>
                        </h1>
                        <div style={{lineHeight:'.5em'}}>
                            <h2 style={{fontSize:'1em'}}>BEng - Software Engineering</h2>
                            <p style={{fontSize:'.85em'}}>2019 - 2023</p>
                        </div>
                        <p style={{fontSize:'1em'}}>My studies at Concordia University laid the foundation for my work in software development and problem-solving.</p>
                    </div>
                    <div className="M9Education">
                        <h1 style={{fontSize:'1.5em'}} className="RefHeader">
                            <a
                                href="https://www.cmaisonneuve.qc.ca/programme/sciences-nature-sciences-sante/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="RefHeader"
                            >
                            Collège de Maisonneuve
                            </a>
                        </h1>
                        <div style={{lineHeight:'.5em'}}>
                            <h2 style={{fontSize:'1em'}}>DEC - Health Science</h2>
                            <p style={{fontSize:'.85em'}}>2016 - 2019</p>
                        </div>
                        <p style={{fontSize:'1em'}}>My DEC in Health Sciences at Collège de Maisonneuve provided a strong grounding in scientific reasoning and analytical thinking.</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HomeEducation;